class Storage {
    static get(key, defaultValue) {
        const value = localStorage.getItem(key)
        return value ? value : defaultValue; 
    }

    static set(key, value) {
        localStorage.setItem(key, value);
    }
}

export default Storage


// WEBPACK FOOTER //
// ./src/storage.js